import React, { useState, useEffect } from "react";
import "../../index.css";
import { gql, useMutation, useQuery } from "@apollo/client";
import Switch from "react-switch";
import Loader from "../../Loader";
import CustomSelect from "../CommonComponents/CustomSelect";
import LabledInput from "../CommonComponents/LabledInput";
import BackButton from "../CommonComponents/BackButton";
import LabeledSwitch from "../CommonComponents/CustomSwitch";
const ADD_PROMOCODE = gql`
  mutation CreatePromocode($data: promocodeInput) {
    addPromocode(data: $data) {
      status
      message
    }
  }
`;
const UPDATE_PROMOCODE = gql`
  mutation updatePromocode(
    $id: ID!
    $name: String
    $type: String
    $gender: String
    $discount: Int
    $promocode: String
    $description: String
    $users: Int
    $minOrder: Int
    $maxDiscount: Int
    $serviceId: ID
    $validFrom: String
    $validTo: String
    $isPercentage: Boolean!
    $isActive: Boolean!
    $hide: Boolean!
    $isServicePromo: Boolean!
    $userIds: [ID!]
    $campaignCode: String
    $newUsersOnly: Boolean
    $maxUsagesPerUser: Int
    $walletCreditAmount: Int
    $walletCreditPercent: Int
    $walletCreditCap: Int
    $autoGrantEnabled: Boolean
  ) {
    updatePromocode(
      data: {
        id: $id
        name: $name
        type: $type
        gender: $gender
        discount: $discount
        promocode: $promocode
        description: $description
        users: $users
        minOrder: $minOrder
        maxDiscount: $maxDiscount
        serviceId: $serviceId
        validFrom: $validFrom
        validTo: $validTo
        isPercentage: $isPercentage
        isActive: $isActive
        hide: $hide
        isServicePromo: $isServicePromo
        userIds: $userIds
        campaignCode: $campaignCode
        newUsersOnly: $newUsersOnly
        maxUsagesPerUser: $maxUsagesPerUser
        walletCreditAmount: $walletCreditAmount
        walletCreditPercent: $walletCreditPercent
        walletCreditCap: $walletCreditCap
        autoGrantEnabled: $autoGrantEnabled
      }
    ) {
      status
      message
    }
  }
`;

const GET_SERVICES = gql`
  query {
    getAdminService {
      services {
        id
        name
      }
    }
  }
`;

const GET_CUSTOMERS = gql`
  query getUserlist($data: UserInput) {
    getUserlist(data: $data) {
      status
      message
      user {
        id
        fullName
      }
    }
  }
`;

const CodeManagementForm = ({ setEditCodeManagementForm, editData }) => {
  // const [updatePromocodeMutation, { loading, error }] = useMutation(UPDATE_PROMOCODE);
  const [updatePromocode, { updateloading, updateerror }] =
    useMutation(UPDATE_PROMOCODE);
  const [addPromocode, { addloading, adderror }] = useMutation(ADD_PROMOCODE);
  const { data, loading, error } = useQuery(GET_SERVICES);

  const {
    data: userdata,
    loading: userloding,
    error: usererror,
    refetch,
  } = useQuery(GET_CUSTOMERS);

  console.log(editData);
  const [isFetched, setIsFetched] = useState(false);
  const [name, setName] = useState(editData?.name || "");
  const [type, setType] = useState(editData?.type || "");
  const [discount, setdiscount] = useState(
    typeof editData?.discount === "number" ? editData?.discount : "",
  );
  const [promocode, setPromocode] = useState(editData?.promocode || "");
  const [description, setDescription] = useState(editData?.description || "");
  const [gender, setGender] = useState(editData?.gender || "");
  const [users, setUsers] = useState(
    typeof editData?.users === "number" ? editData?.users : "",
  );
  const [minorder, setMinOrder] = useState(
    typeof editData?.minOrder === "number" ? editData?.minOrder : "",
  );
  const [maxdiscount, setMaxDiscount] = useState(
    typeof editData?.maxDiscount === "number" ? editData?.maxDiscount : "",
  );
  const [campaignCode, setCampaignCode] = useState(
    editData?.campaignCode || "",
  );
  // maxTotalUsages ("Number of Users*" below) caps total redemptions across
  // everyone; this caps redemptions per individual user. Blank = unlimited.
  const [maxUsagesPerUser, setMaxUsagesPerUser] = useState(
    typeof editData?.maxUsagesPerUser === "number"
      ? editData?.maxUsagesPerUser
      : "",
  );
  // Mirrors PromotionSyncService.mapAudienceType: newUsersOnly takes
  // priority over a specific-users list, so the two are mutually exclusive.
  const [newUsersOnly, setNewUsersOnly] = useState(
    editData?.newUsersOnly ?? false,
  );
  // Mirrors PromotionSyncService.mapRewardTypeAndConfig: a promo is either
  // an instant order discount or a wallet cashback, never both.
  const [rewardType, setRewardType] = useState(
    editData?.walletCreditAmount > 0 || editData?.walletCreditPercent > 0
      ? "WALLET_CREDIT"
      : "DISCOUNT",
  );
  const [walletCreditMode, setWalletCreditMode] = useState(
    editData?.walletCreditPercent > 0 ? "PERCENT" : "FLAT",
  );
  const [walletCreditAmount, setWalletCreditAmount] = useState(
    typeof editData?.walletCreditAmount === "number"
      ? editData?.walletCreditAmount
      : "",
  );
  const [walletCreditPercent, setWalletCreditPercent] = useState(
    typeof editData?.walletCreditPercent === "number"
      ? editData?.walletCreditPercent
      : "",
  );
  const [walletCreditCap, setWalletCreditCap] = useState(
    typeof editData?.walletCreditCap === "number"
      ? editData?.walletCreditCap
      : "",
  );
  // Explicit admin opt-in - only takes effect once code is empty and this
  // isn't a service promo (see create-booking.js's discovery query, which
  // requires code: null, serviceId: null, autoGrantEnabled: true).
  const [autoGrantEnabled, setAutoGrantEnabled] = useState(
    editData?.autoGrantEnabled ?? false,
  );

  console.log("helloo");
  const [validfrom, setValidFromDate] = useState(
    editData?.validFrom
      ? new Date(editData?.validFrom).toISOString().slice(0, 10)
      : "",
  );
  const [validto, setValidToDate] = useState(
    editData?.validTo
      ? new Date(editData?.validTo).toISOString().slice(0, 10)
      : "",
  );

  const [service, setService] = useState(editData?.serviceId || "");
  const [serviceList, setServiceList] = useState([]);

  const [isPercentage, setIsPercentage] = useState(
    editData?.isPercentage ?? true,
  );
  const [isActive, setIsActive] = useState(editData?.isActive ?? true);
  const [isHide, setIsHide] = useState(editData?.hide ?? true);
  const [isServicePromo, setIsServicePromo] = useState(
    editData?.isServicePromo ?? true,
  );
  const [phoneNumber, setPhoneNumber] = useState("");
  const [foundUser, setFoundUser] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);

  //convert the ids in the suitable format;
  // let userid=editData.userIds;
  // if(userid.length){
  //   for(let i=0;i<userid.length;i++){
  //     refetch({ data: {id:userid[i]} })
  //     .then((res) => {
  //       console.log("getuser  hitted");
  //       console.log(res.data.getUserlist.user);
  //       if (res.data.getUserlist.status === "SUCCESS") {
  //         const userList = res.data.getUserlist.user; // Store fetched data in a variable
  //         setSelectedUsers(...selectedUsers,userList[0]) // Use the fetched data directly
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   }
  // setFoundUser(selectedUsers.length > 0 ? selectedUsers : null);
  // }
  //   let userids = editData.userIds;

  // if (userids && userids.length) {
  //   const fetchPromises = userids.map(id =>
  //     refetch({ data: { id} })
  //       .then(res => {
  //         console.log("getuser hitted");
  //         console.log(res.data.getUserlist.user);
  //         if (res.data.getUserlist.status === "SUCCESS") {
  //           return res.data.getUserlist.user[0]; // Return the fetched user
  //         }
  //         return null; // Return null if fetching fails
  //       })
  //       .catch(err => {
  //         console.log(err);
  //         return null; // Return null on error
  //       })
  //   );

  //   Promise.all(fetchPromises).then(fetchedUsers => {
  //     const validUsers = fetchedUsers.filter(user => user !== null);
  //     setSelectedUsers(prevSelectedUsers => [...prevSelectedUsers, ...validUsers]);
  //     console.log("jai ho bhaiya ki")

  //   });
  // }
  useEffect(() => {
    let userid = editData?.userIds ?? [];
    if (userid.length) {
      // Fetch all user data in parallel using Promise.all
      Promise.all(
        userid.map((id) =>
          refetch({ variables: { id: id } })
            .then((res) => {
              console.log("getUser API hit", id);
              if (res.userdata?.getUserlist?.status === "SUCCESS") {
                console.log(res.userdata.getUserlist.user);
                return res.userdata.getUserlist.user[0]; // Return the user
              }
              console.log("not found");
              return null;
            })
            .catch((err) => {
              console.error("Error fetching user:", err);
              return null;
            }),
        ),
      ).then((fetchedUsers) => {
        const validUsers = fetchedUsers.filter((user) => user !== null); // Remove null values
        setSelectedUsers(validUsers); // Update state once (prevents infinite loop)
      });
    }
    setFoundUser(selectedUsers.length > 0 ? selectedUsers : null);
  }, [editData?.userIds]); // Dependency array ensures it runs only when `editData.userIds` changes
  const handleRemoveUser = (id) => {
    setSelectedUsers((prev) => prev.filter((user) => user.id !== id));
  };
  const handleSearch = () => {
    refetch({ data: { contactNumber: phoneNumber } })
      .then((res) => {
        console.log("getuser  hitted");
        console.log(res.data.getUserlist.user);
        if (res.data.getUserlist.status === "SUCCESS") {
          const userList = res.data.getUserlist.user; // Store fetched data in a variable
          setFoundUser(userList.length > 0 ? userList : null); // Use the fetched data directly
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Function to add user to selected list
  const handleSelectUser = () => {
    if (
      foundUser &&
      !selectedUsers.some((user) => user.id === foundUser[0].id)
    ) {
      setSelectedUsers([...selectedUsers, foundUser[0]]);
      setFoundUser(null);

      setPhoneNumber(""); // Reset input after selection
    }
  };

  useEffect(() => {
    if (data?.getAdminService?.services) {
      console.log("get service called");
      console.log(data.getAdminService.services);
      setServiceList(data.getAdminService.services);
      setIsFetched(true);
    }
  }, [data]);

  // const handleClick = async () => {
  //   try {
  //     const { data } = await deleteCustomerMutation({variables:{
  //       id: editData.id,name:name,type:type,promocode:promoCode,discount:parseInt(off)
  //     }})
  //     setData(data)
  //   }
  //   catch (e) {
  //     console.log(e);
  //   }
  // }
  // Auto-grant only ever fires from create-booking.js's discovery query,
  // which requires code: null, serviceId: null, autoGrantEnabled: true on a
  // WALLET_CREDIT promo - so the toggle is meaningless (and hidden/disabled)
  // outside that combination. See canAutoGrant below, used to render it.
  const canAutoGrant =
    !isServicePromo && rewardType === "WALLET_CREDIT" && promocode.trim() === "";

  const validate = () => {
    if (!isServicePromo && rewardType === "WALLET_CREDIT") {
      const hasAmount = walletCreditAmount !== "" && Number(walletCreditAmount) > 0;
      const hasPercent = walletCreditPercent !== "" && Number(walletCreditPercent) > 0;
      if (walletCreditMode === "FLAT" && !hasAmount) {
        return "Enter a wallet credit amount greater than 0.";
      }
      if (walletCreditMode === "PERCENT" && !hasPercent) {
        return "Enter a wallet credit percent greater than 0.";
      }
    }
    if (newUsersOnly && selectedUsers.length > 0) {
      return "\"New Users Only\" and specific selected users can't both be set - remove the selected users or turn off \"New Users Only\".";
    }
    return null;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationError = validate();
    if (validationError) {
      alert(validationError);
      return;
    }

    let userids = selectedUsers.map((user) => user.id);

    let finalDataObj = {};
    if (editData?.id) finalDataObj.id = editData.id;
    finalDataObj.name = name;
    finalDataObj.type = type;
    if (discount !== "") finalDataObj.discount = parseInt(discount);
    finalDataObj.promocode = promocode;
    finalDataObj.description = description;
    if (users !== "") finalDataObj.users = parseInt(users);
    if (minorder !== "") finalDataObj.minOrder = parseInt(minorder);
    if (maxdiscount !== "") finalDataObj.maxDiscount = parseInt(maxdiscount);
    finalDataObj.serviceId = service;
    finalDataObj.maxUsagesPerUser =
      maxUsagesPerUser !== "" ? parseInt(maxUsagesPerUser) : null;
    finalDataObj.newUsersOnly = newUsersOnly;

    // Wallet-credit fields are always sent (never left undefined) so
    // switching a promo's reward type explicitly clears the other type's
    // fields - see PromotionSyncService.mapRewardTypeAndConfig.
    if (!isServicePromo && rewardType === "WALLET_CREDIT") {
      finalDataObj.walletCreditAmount =
        walletCreditMode === "FLAT" && walletCreditAmount !== ""
          ? parseInt(walletCreditAmount)
          : null;
      finalDataObj.walletCreditPercent =
        walletCreditMode === "PERCENT" && walletCreditPercent !== ""
          ? parseInt(walletCreditPercent)
          : null;
      finalDataObj.walletCreditCap =
        walletCreditMode === "PERCENT" && walletCreditCap !== ""
          ? parseInt(walletCreditCap)
          : null;
      finalDataObj.autoGrantEnabled = canAutoGrant && autoGrantEnabled;
    } else {
      finalDataObj.walletCreditAmount = null;
      finalDataObj.walletCreditPercent = null;
      finalDataObj.walletCreditCap = null;
      finalDataObj.autoGrantEnabled = false;
    }

    if (validfrom !== "")
      finalDataObj.validFrom = new Date(validfrom).toISOString();
    if (validto !== "") finalDataObj.validTo = new Date(validto).toISOString();

    finalDataObj.isPercentage = isPercentage;
    finalDataObj.isActive = isActive;
    finalDataObj.hide = isHide;
    finalDataObj.isServicePromo = isServicePromo;
    finalDataObj.gender = gender;
    finalDataObj.userIds = userids;
    if (campaignCode.trim().length === 0) {
      finalDataObj.campaignCode = null;
    } else {
      finalDataObj.campaignCode = campaignCode.trim();
    }

    // if (userids) finalDataObj.userIds = userids;
    // updatePromocode({
    //   variables: {
    //     ...finalDataObj,
    //   },
    // })
    //   .then((res) => {
    //     console.log("add promocode res is");
    //     console.log(res);
    //     if (res.data.updatePromocode.status === "SUCCESS") {
    //       window.location.reload();
    //       // window.location = "/admin/promocode";
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });

    // console.log(finalDataObj);
    if (editData?.id) {
      updatePromocode({
        variables: finalDataObj,
      })
        .then((res) => {
          console.log(res);
          if (res.data.updatePromocode.status === "SUCCESS") {
            window.location.reload();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      addPromocode({
        variables: { data: finalDataObj },
      })
        .then((res) => {
          console.log(res);
          if (res.data.addPromocode.status === "SUCCESS") {
            window.location.reload();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  if (loading || !isFetched) return <Loader />;

  return (
    <>
      <div>
        {isFetched && (
          <div className="flex flex-col py-3 px-2 space-y-5">
            <BackButton onClick={() => setEditCodeManagementForm(false)} />
            <h3 className="text-[#FBB033] font-be-jost-pro font-bold text-2xl">
              {editData ? "Edit" : "Add"} Code Management
            </h3>
            <h3
              className="w-full flex items-center justify-end cursor-pointer text-white"
              onClick={() => setEditCodeManagementForm(false)}
            >
              <p className="w-6 h-6">×</p>
            </h3>
            <div className="w-full flex flex-col space-y-8">
              <LabledInput
                value={name}
                onChange={(e) => setName(e.target.value)}
                label={"Name*"}
                placeholder={"Type name here..."}
              />
              <div className="flex flex-col md:flex-row gap-4">
                <LabledInput
                  type="date"
                  onChange={(e) => setValidFromDate(e.target.value)}
                  value={validfrom}
                  label={"Validity*"}
                  placeholder={"Select Valid From Date"}
                />
                <LabledInput
                  type="date"
                  onChange={(e) => setValidToDate(e.target.value)}
                  value={validto}
                  placeholder={"Select Valid To Date"}
                />
              </div>
              <LabeledSwitch
                checked={newUsersOnly}
                onChange={(checked) => {
                  setNewUsersOnly(checked);
                  // Mutually exclusive with a specific-users list on the
                  // backend (mapAudienceType) - clear it so the UI doesn't
                  // show selections that will silently be ignored.
                  if (checked) setSelectedUsers([]);
                }}
                label={"New Users Only"}
                leftLabel="No"
                rightLabel="Yes"
              />
              <LabledInput
                type="text"
                label={"Campaign Code"}
                placeholder="Type Campaign Code here..."
                value={campaignCode}
                onChange={(e) => setCampaignCode(e.target.value)}
              />

              <div
                className={`space-y-4 ${newUsersOnly ? "opacity-40 pointer-events-none" : ""}`}
              >
                {newUsersOnly && (
                  <p className="text-white text-xs">
                    Turn off "New Users Only" to target specific users instead.
                  </p>
                )}
                {/* Search Input & Button */}
                <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
                  <LabledInput
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    maxLength={10}
                    label="Users"
                    placeholder="Search mobile number to whom you want to enable..."
                    className="flex-1"
                  />
                  <button
                    onClick={handleSearch}
                    className="px-4 py-2 bg-[#FBB034] text-black rounded hover:bg-[#e5a421] transition"
                  >
                    Search
                  </button>
                </div>

                {/* Found User */}
                {foundUser && (
                  <div className="flex items-center justify-between bg-[#1a1a1a] p-2 rounded border border-[#333]">
                    <span className="text-white">{foundUser[0].fullName}</span>
                    <button
                      className="px-3 py-1 bg-green-600 rounded text-white hover:bg-green-700 transition"
                      onClick={handleSelectUser}
                    >
                      Select
                    </button>
                  </div>
                )}

                {/* Selected Users */}
                {selectedUsers.length > 0 && (
                  <div className="bg-[#1a1a1a] p-4 rounded border border-[#333]">
                    <h3 className="text-md mb-2 text-[#FBB034]">
                      Selected Users:
                    </h3>
                    <ul className="space-y-2">
                      {selectedUsers.map((user) => (
                        <li
                          key={user.id}
                          className="flex items-center justify-between text-white bg-[#0f0f0f] px-3 py-2 rounded"
                        >
                          <span>{user.fullName}</span>
                          <button
                            onClick={() => handleRemoveUser(user.id)}
                            className="ml-2 text-red-500 hover:text-red-700 transition"
                          >
                            ✕
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              <CustomSelect
                label="Gender*"
                placeholder="Select Gender"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                options={["Male", "Female"]}
                required={true}
                inline
                showReset // ✅ enables Reset button
              />
              <LabledInput
                type="number"
                value={minorder}
                onChange={(e) => setMinOrder(e.target.value)}
                label={"Min Order*"}
                placeholder={
                  "Type min order amount on which you want to enable this..."
                }
              />

              <LabeledSwitch
                checked={isServicePromo}
                onChange={(e) => setIsServicePromo(e)}
                label={"Coupon Type"}
                leftLabel="Coupon Code"
                rightLabel="Service Promo"
              />
              {isServicePromo ? (
                <CustomSelect
                  label="Service*"
                  placeholder="Select Service"
                  value={service}
                  onChange={(e) => setService(e.target.value)}
                  options={serviceList}
                  required={true} // not mandatory now
                  inline
                  showReset // ✅ enables Reset button
                />
              ) : (
                <>
                  <LabledInput
                    type="text"
                    label={"Promo Code*"}
                    placeholder="Type Promo Code here (this will be shown to user)..."
                    value={promocode}
                    onChange={(e) => setPromocode(e.target.value)}
                  />
                  <LabledInput
                    type="text"
                    label={"Description*"}
                    placeholder="Add description here..."
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  <LabledInput
                    type="number"
                    placeholder="Number of Users to be enabled"
                    label={"Number of Users*"}
                    value={users}
                    onChange={(e) => setUsers(e.target.value)}
                  />
                  <LabledInput
                    type="number"
                    placeholder="Leave blank for unlimited redemptions per user"
                    label={"Max Uses Per User"}
                    value={maxUsagesPerUser}
                    onChange={(e) => setMaxUsagesPerUser(e.target.value)}
                  />
                  <LabeledSwitch
                    checked={rewardType === "WALLET_CREDIT"}
                    onChange={(checked) =>
                      setRewardType(checked ? "WALLET_CREDIT" : "DISCOUNT")
                    }
                    label={"Reward Type"}
                    leftLabel="Discount"
                    rightLabel="Wallet Credit"
                  />
                  {rewardType === "DISCOUNT" ? (
                    <>
                      <LabeledSwitch
                        checked={isPercentage}
                        onChange={(e) => setIsPercentage(e)}
                        label={"Discount Type"}
                        leftLabel="Flat discount"
                        rightLabel="% discount"
                      />
                      {isPercentage && (
                        <LabledInput
                          label={"Discount %*"}
                          type="number"
                          placeholder="Type % discount here..."
                          value={discount}
                          onChange={(e) => setdiscount(e.target.value)}
                        />
                      )}
                      <LabledInput
                        type="number"
                        placeholder="Type Discount Amount"
                        label={isPercentage ? "Max Discount*" : "Discount Amount*"}
                        value={maxdiscount}
                        onChange={(e) => setMaxDiscount(e.target.value)}
                      />
                    </>
                  ) : (
                    <>
                      <LabeledSwitch
                        checked={walletCreditMode === "PERCENT"}
                        onChange={(checked) =>
                          setWalletCreditMode(checked ? "PERCENT" : "FLAT")
                        }
                        label={"Wallet Credit Type"}
                        leftLabel="Flat amount"
                        rightLabel="% of order"
                      />
                      {walletCreditMode === "FLAT" ? (
                        <LabledInput
                          type="number"
                          label={"Wallet Credit Amount*"}
                          placeholder="Type flat wallet credit amount here..."
                          value={walletCreditAmount}
                          onChange={(e) => setWalletCreditAmount(e.target.value)}
                        />
                      ) : (
                        <>
                          <LabledInput
                            type="number"
                            label={"Wallet Credit %*"}
                            placeholder="Type % of order value to credit..."
                            value={walletCreditPercent}
                            onChange={(e) => setWalletCreditPercent(e.target.value)}
                          />
                          <LabledInput
                            type="number"
                            label={"Wallet Credit Cap"}
                            placeholder="Leave blank for no cap - cashback can exceed order value"
                            value={walletCreditCap}
                            onChange={(e) => setWalletCreditCap(e.target.value)}
                          />
                        </>
                      )}
                      {canAutoGrant ? (
                        <LabeledSwitch
                          checked={autoGrantEnabled}
                          onChange={(checked) => setAutoGrantEnabled(checked)}
                          label={"Auto-Grant (no code needed)"}
                          leftLabel="Off"
                          rightLabel="On"
                        />
                      ) : (
                        <p className="text-white text-xs">
                          Auto-grant is only available for a Wallet Credit
                          reward with no Promo Code set (leave the code blank
                          above to enable it).
                        </p>
                      )}
                    </>
                  )}
                  <LabeledSwitch
                    checked={isHide}
                    onChange={(e) => setIsHide(e)}
                    label={"Hide Status"}
                    leftLabel="Not Hidden"
                    rightLabel="Hidden"
                  />
                  <LabeledSwitch
                    checked={isActive}
                    onChange={(e) => setIsActive(e)}
                    label={"Active Status"}
                    leftLabel="Inactive"
                    rightLabel="Active"
                  />
                </>
              )}

              <div className="flex items-center justify-center">
                <button
                  className="bg-[#FBB034] text-[#202125] py-2 px-6 rounded-md font-poppins text-sm font-bold"
                  onClick={handleSubmit}
                >
                  {editData ? "Update" : "Add"} Promocode
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CodeManagementForm;
